<template>
  <div class="ExpartiateList">
    <el-card shadow="never">
      <div class="title_button">
        <div class="left" style="width: 100%; display: flex">
          <div style="width: 447px">
            <h4>
              {{ $lange == "en" ? "Job Order" : "外派工单" }}:{{
                expatriateDataV2.id
              }}
            </h4>
          </div>
          <div style="width: 235px">
            <span>{{ $lange == "en" ? "Status：" : "状态：" }}</span>
            <el-select
              v-if="showEdit"
              v-model="from.status"
              placeholder=""
              size="mini"
              style="width: 130px"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <template v-else>{{
              statusText[expatriateDataV2.status]
            }}</template>
          </div>
          <div>
            <span>{{ $lange == "en" ? "Responsible：" : "处理人：" }}</span>
            <el-select
              v-if="showEdit"
              v-model="from.handlerId"
              placeholder=""
              size="mini"
            >
              <el-option
                v-for="item in userSelectorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <template v-else>{{
              showhandlerId(expatriateDataV2.handlerId)
            }}</template>
          </div>
        </div>
        <div class="right" v-if="isHandleV2">
          <p
            class="btn-group flex-between"
            v-if="from.status == 3 && !showEdit"
          >
            <el-button
              size="mini"
              type="primary"
              @click="allAudit"
              style="width: 150px"
              >{{ $lange == "en" ? "Approve all" : "全部审核通过" }}</el-button
            >
          </p>
          <p class="btn-group flex-between" v-if="!showEdit">
            <el-button
              size="mini"
              type="primary"
              @click="openEdit"
              style="width: 150px"
              >{{ $lange == "en" ? "Edit" : "编辑" }}</el-button
            >
          </p>
          <p class="btn-group flex-between" v-else>
            <el-button size="mini" @click="cancelEdit" style="width: 150px">{{
              $lange == "en" ? "Cancel" : "取消修改"
            }}</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="orderSave"
              style="width: 150px"
              >{{ $lange == "en" ? "Save" : "保存修改" }}</el-button
            >
          </p>
        </div>
      </div>
    </el-card>

    <div class="wrap">
      <div class="card">
        <!-- <div class="add_title">
          <span class="title" style="">外派工单明细</span>
          <div v-if="!showEdit">
            <span v-if="expatriateData.isConfirm == 0"
              >方案确认状态：未确认</span
            >
            <span v-if="expatriateData.isConfirm == 1"
              >方案确认状态：客户确认</span
            >
            <span v-if="expatriateData.isConfirm == 2"
              >方案确认状态：客户拒绝</span
            >
          </div>
        </div> -->
        <cc-table
          :config="expartiateListTable"
          :data-arr="expartiateList"
          :load-data="false"
        ></cc-table>
        <div class="count_wrap" v-if="serviceInvitation">
          <div class="" style="display: flex">
            <div class="file2">
              <div class="file2_title">
                {{ $lange == "en" ? "Attachement" : "附件" }}：
              </div>
              <div>
                <div
                  v-if="
                    !serviceInvitation.accessoryUrl ||
                    serviceInvitation.accessoryUrl == ''
                  "
                >
                  {{ $lange == "en" ? "Null" : "无" }}
                </div>

                <div class="file2_list" v-if="serviceInvitation.accessoryUrl">
                  <el-link
                    :href="serviceInvitation.accessoryUrl"
                    target="_blank"
                    >{{
                      serviceInvitation.fileName
                        ? serviceInvitation.fileName
                        : serviceInvitation.accessoryUrl
                    }}</el-link
                  >
                  <span
                    v-if="showEdit"
                    @click="deleteAccessoryInfoList"
                    style="margin-left: 10px; color: red"
                    >删除</span
                  >
                </div>
              </div>
              <div style="margin-left: 10px">
                <el-button
                  v-if="
                    showEdit &&
                    (!serviceInvitation.accessoryUrl ||
                      serviceInvitation.accessoryUrl == '')
                  "
                  size="mini"
                  style="width: 100%"
                  @click="openUploaderDialog = true"
                  >上传附件</el-button
                >
              </div>
            </div>
            <div v-if="!showEdit">
              <span v-if="expatriateData.isConfirm == 0"
                ><span style="font-weight: 700">{{
                  $lange == "en" ? "Customer confirm" : "客户是否确认"
                }}</span
                >：{{ $lange == "en" ? "No" : "未确认" }}</span
              >
              <span v-if="expatriateData.isConfirm == 1"
                ><span style="font-weight: 700">{{
                  $lange == "en" ? "Customer confirm" : "客户是否确认"
                }}</span
                >：{{ $lange == "en" ? "Yes" : "客户确认" }}</span
              >
              <span v-if="expatriateData.isConfirm == 2"
                ><span style="font-weight: 700">{{
                  $lange == "en" ? "Customer confirm" : "客户是否确认"
                }}</span
                >：{{ $lange == "en" ? "Rejected" : "客户拒绝" }}</span
              >
            </div>
          </div>
          <div
            v-if="
              !showEdit &&
              isHandleV2 &&
              (expatriateData.isConfirm == 0 || expatriateData.isConfirm == 2)
            "
          >
            <el-button size="mini" @click="sendMes" style="min-width: 150px">{{
              $lange == "en" ? "Sent to customer" : "推送客户"
            }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$lange == 'en' ? 'Create a Job Order' : '添加外派需求'"
      :visible.sync="addPartsFlag"
      width="90%"
      append-to-body
    >
      <template v-if="addPartsFlag">
        <el-form
          :model="editData"
          :rules="rules"
          ref="ruleForm"
          :label-width="$lange == 'en' ? '140px' : '120px'"
          class="demo-ruleForm"
        >
          <el-form-item
            :label="$lange == 'en' ? 'Cost Type' : '费用类型:'"
            prop="feeType"
            required
          >
            <el-select v-model="editData.feeType" placeholder="" size="small">
              <el-option :label="$lange == 'en' ? 'Free' : '保内'" :value="0">{{
                $lange == "en" ? "Free" : "保内"
              }}</el-option>
              <el-option :label="$lange == 'en' ? 'Paid' : '保外'" :value="1">{{
                $lange == "en" ? "Paid" : "保外"
              }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'Planned From' : '预计开始时间:'"
            required
            prop="startTime"
          >
            <el-date-picker
              type="date"
              placeholder=""
              v-model="editData.startTime"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType1"
            v-if="editData.employeeType1"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Mechanic" : "机械工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType1.num"
                @input="changeNum"
                style="width: 100px; margin-right: 20px"
                :min="0.1"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType1.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
                :min="0.1"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType1.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType2"
            v-if="editData.employeeType2"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Electrical" : "电气工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType2.num"
                @input="changeNum"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType2.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType2.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            v-if="editData.employeeType3"
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType3"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Software" : "软件工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType3.num"
                @input="changeNum"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType3.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType3.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            v-if="editData.employeeType4"
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType4"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Quality" : "质量工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType4.num"
                @input="changeNum"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType4.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType4.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <div class="button_wrap">
            <el-button @click="addPartsFlag = false" size="mini"
              >取消</el-button
            >
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              size="mini"
              >确认修改</el-button
            >
          </div>
        </el-form>
      </template>
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="openUploaderDialog"
      width="30%"
      append-to-body
    >
      <template v-if="openUploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedMultiple"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="cancelRemarkFlag" width="50%" append-to-body>
      <h3 class="cancelRemark_title">请确认是否取消本外派订单吗?</h3>
      <el-input
        type="textarea"
        placeholder=""
        v-model="cancelRemarkText"
        :autosize="{ minRows: 10, maxRows: 10 }"
      >
      </el-input>
      <div class="cancelRemark_btn">
        <el-button size="small" @click="cancelRemarkFlag = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="cancelRemark"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    expatriateData: Object,
    isHandleV2: Boolean,
  },
  data() {
    return {
      roleTips: "",
      uploaderConf2: this.$uploadUtils.config, //文件上传需要
      userSelectorList: [],
      showEdit: false,
      from: {},
      statusText: [
        "草稿",
        this.$lange == "en" ? "New" : "新申请",
        this.$lange == "en" ? "Customer Action" : "待客户确认",
        this.$lange == "en" ? "Waiting Approval" : "待审批",
        this.$lange == "en" ? "Engineer Preparing" : "等待派工",
        this.$lange == "en" ? "On working" : "服务中",
        this.$lange == "en" ? "Completed" : "已完成",
        this.$lange == "en" ? "Close" : "已关闭",
        this.$lange == "en" ? "Cancel" : "已取消",
      ],
      status: [
        // {
        //   label: "草稿",
        //   value: 0,
        // },
        {
          label: this.$lange == "en" ? "New" : "新申请",
          value: 1,
        },
        {
          label: this.$lange == "en" ? "Customer Action" : "待客户确认",
          value: 2,
        },
        {
          label: this.$lange == "en" ? "Waiting Approval" : "待审批",
          value: 3,
        },
        {
          label: this.$lange == "en" ? "Engineer Preparing" : "等待派工",
          value: 4,
        },
        {
          label: this.$lange == "en" ? "On working" : "服务中",
          value: 5,
        },
        {
          label: this.$lange == "en" ? "Completed" : "已完成",
          value: 6,
        },
        // {
        //   label: "已关闭",
        //   value: 7,
        // },
        {
          label: this.$lange == "en" ? "Cancel" : "已取消",
          value: 8,
        },
      ],
      expatriateDataV2: {},

      expartiateListTable: {
        columns: [
          {
            prop: "employeeType",
            lable: this.$lange == "en" ? "Engineer Type" : "工程师类别",
            minWidth: 90,
            render: (row) => {
              // return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
              //   row.employeeType
              // ];
              if (this.$lange == "en") {
                return ["Mechanic", "Electrical", "Software", "Quality"][
                  row.employeeType
                ];
              } else {
                return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
                  row.employeeType
                ];
              }
            },
          },
          {
            prop: "num",
            lable: this.$lange == "en" ? "Quantity" : "人数",
            minWidth: 50,
          },
          {
            prop: "preWorkHour",
            lable: this.$lange == "en" ? "Plan Working Hours" : "预计总工时",
            minWidth: 50,
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Scheduled to go" : "计划开始",
            minWidth: 90,
            render: (row) => {
              if (row.startTime) {
                return moment(row.startTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            prop: "endTime",
            lable: this.$lange == "en" ? "Scheduled to" : "计划结束",
            minWidth: 90,
            render: (row) => {
              if (row.endTime) {
                return moment(row.endTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            prop: "feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 80,
            // render: (row) => {
            //   if (this.$lange == "en") {
            //     return ["Free", "Paid"][row.feeType];
            //   } else {
            //     return ["保内", "保外"][row.feeType];
            //   }
            // },
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            minWidth: 100,
          },
          {
            prop: "isAudit",
            lable: this.$lange == "en" ? "Approval" : "审核",
            minWidth: 80,
            render: (row) => {
              let text = ["待审批", "通过", "拒绝"];
              return text[row.isAudit];
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          // {
          //   name: this.$lange == "en" ? "Edit" : "修改",
          //   click: (row, $index) => {
          //     let editData = {
          //       employeeType1: {
          //         num: "",
          //         preWorkHour: "",
          //         remark: "",
          //       },
          //       employeeType2: {
          //         num: "",
          //         preWorkHour: "",
          //         remark: "",
          //       },
          //       startTime: this.expartiateList[0].startTime,
          //       feeType: this.expatriateData.feeType,
          //     };
          //     let expartiateList = this.expartiateList;
          //     for (let index = 0; index < expartiateList.length; index++) {
          //       if (expartiateList[index].employeeType == 0) {
          //         editData.employeeType1 = {
          //           ...expartiateList[index],
          //         };
          //       } else {
          //         editData.employeeType2 = {
          //           ...expartiateList[index],
          //         };
          //       }
          //     }
          //     console.log(editData);
          //     this.editData = editData;
          //     this.addPartsFlag = true;
          //   },
          // },
        ],
      },
      expartiateList: [],
      addPartsFlag: false,
      editData: {},
      rules: {
        feeType: [{ required: true, message: "不可为空", trigger: "blur" }],
        startTime: [{ required: true, message: "不可为空", trigger: "blur" }],
      },
      serviceInvitation: {
        accessoryUrl: "",
      },
      openUploaderDialog: false,
      cancelRemarkText: "",
      cancelRemarkFlag: false,
    };
  },
  watch: {
    expatriateData: {
      handler() {
        console.log(this.expatriateData, "expatriateData");
        this.expatriateDataV2 = {
          ...this.expatriateData,
        };
        this.from = {
          ...this.expatriateData,
        };
        // this.fromData.handlerId = this.expatriateData.handlerId * 1;
        if (this.expatriateData.serviceInvitation) {
          this.serviceInvitation = { ...this.expatriateData.serviceInvitation };
          // this.serviceInvitation =JSON.parse(JSON.stringify(this.expatriateData.serviceInvitation));
        }
        this.expartiateList = [...this.expatriateData.expatriatePlanList];
        for (let index = 0; index < this.expartiateList.length; index++) {
          this.expartiateList[index].feeType = this.expatriateData.feeType;
        }

        //按钮操作
        let buttons = [];
        if (this.isHandleV2) {
          if (
            this.expatriateData.status == 1 ||
            this.expatriateData.status == 2
          ) {
            buttons.push({
              name: this.$lange == "en" ? "Edit" : "修改",
              click: (row, $index) => {
                let editData = {
                  employeeType1: {
                    num: "",
                    preWorkHour: "",
                    remark: "",
                  },
                  employeeType2: {
                    num: "",
                    preWorkHour: "",
                    remark: "",
                  },
                  employeeType3: {
                    num: "",
                    preWorkHour: "",
                    remark: "",
                  },
                  employeeType4: {
                    num: "",
                    preWorkHour: "",
                    remark: "",
                  },
                  startTime: this.expartiateList[0].startTime,
                  feeType: this.expatriateData.feeType,
                };
                let expartiateList = this.expartiateList;
                for (let index = 0; index < expartiateList.length; index++) {
                  if (expartiateList[index].employeeType == 0) {
                    editData.employeeType1 = {
                      ...expartiateList[index],
                    };
                  } else if (expartiateList[index].employeeType == 1) {
                    editData.employeeType2 = {
                      ...expartiateList[index],
                    };
                  } else if (expartiateList[index].employeeType == 2) {
                    editData.employeeType3 = {
                      ...expartiateList[index],
                    };
                  } else if (expartiateList[index].employeeType == 3) {
                    editData.employeeType4 = {
                      ...expartiateList[index],
                    };
                  }
                }
                console.log(editData);
                this.editData = editData;
                this.addPartsFlag = true;
              },
              check: (row) => {
                if (this.showEdit) {
                  return true;
                }
                return false;
              },
            });
          } else if (this.expatriateData.status == 3) {
            buttons.push({
              name: this.$lange == "en" ? "Approve" : "通过",
              click: (row, $index) => {
                this.audit(row, 1);
              },
              check: (row) => {
                return !this.showEdit ? true : false;
                // if (row.isAudit == 0) {
                //   return true;
                // }
                // return false;
              },
            });
            buttons.push({
              name: this.$lange == "en" ? "Reject" : "退回",
              click: (row, $index) => {
                this.audit(row, 2);
              },
              check: (row) => {
                return !this.showEdit ? true : false;
                // if (row.isAudit == 0) {
                //   return true;
                // }
                // return false;
              },
            });
          } else if (this.from.status == 4) {
            //废弃
            // buttons.push({
            //   name: this.$lange == "en" ? "退回/取消" : "退回/取消",
            //   click: (row, $index) => {
            //     this.openBackAudit(row);
            //   },
            // });
            // buttons.push({
            //   name: "",
            //   click: (row, $index) => {},
            // });
          }
        }

        this.expartiateListTable.buttons = buttons;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  methods: {
    changeNum(e) {
      console.log(e);
      if (e.indexOf(".") > -1) {
        this.$message.error("预计人数请填大于0的整数");
        return false;
      }
    },
    changePreWorkHour(e) {
      if (e < 0) {
        this.$message.error("预计总工时请填大于0的整数");
        return false;
      }
    },
    showhandlerId(e) {
      let name = e;
      for (let index = 0; index < this.userSelectorList.length; index++) {
        if (this.userSelectorList[index].id == e) {
          name = this.userSelectorList[index].name;
          break;
        }
      }
      return name;
    },
    getUserList() {
      //engineer 工程师，projectManager 项目经理，accessoriesSpecialist 配件专员，technicalSupport 技术支持工程师 ，afterSalesManager  售后经理
      let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
      this.ccRequest
        .do(
          api,
          [
            "accessoriesSpecialist",
            "projectManager",
            "technicalSupport",
            "afterSalesManager",
          ],
          "POSTJSON"
        )
        .then((res) => {
          //默认处理人
          if (!this.expatriateDataV2.handlerId && res.length > 0) {
            this.from.handlerId = res[0].id;
            this.expatriateDataV2.handlerId = res[0].id;
          }
          this.userSelectorList = res;
        });
    },
    openEdit() {
      //恢復原始數據
      this.showEdit = true;
      this.from = {
        ...this.expatriateData,
      };
      this.expartiateList = [...this.expatriateData.expatriatePlanList];
      for (let index = 0; index < this.expartiateList.length; index++) {
        this.expartiateList[index].feeType = this.expatriateData.feeType;
      }
      this.serviceInvitation = { ...this.expatriateData.serviceInvitation };
    },
    cancelEdit() {
      this.showEdit = false;
      //恢復原始數據
      this.from = {
        ...this.expatriateData,
      };
      this.expartiateList = [...this.expatriateData.expatriatePlanList];
      for (let index = 0; index < this.expartiateList.length; index++) {
        this.expartiateList[index].feeType = this.expatriateData.feeType;
      }
      this.serviceInvitation = { ...this.expatriateData.serviceInvitation };
    },
    getData() {
      this.ccRequest
        .do(
          "admin/fsb/expatriate/get",
          ["accessoriesSpecialist", "projectManager", "technicalSupport"],
          "POSTJSON"
        )
        .then((res) => {
          this.userSelectorList = res;
        });
    },
    uploadTrue(e) {
      this.serviceInvitation = {
        ...this.serviceInvitation,
        ...e,
      };
      this.openUploaderDialog = false;
    },
    deleteAccessoryInfoList() {
      this.serviceInvitation = {
        // accessoryUrl: "",
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.fromData);
          if (
            this.editData.employeeType1.num ||
            this.editData.employeeType1.preWorkHour ||
            this.editData.employeeType1.remark
          ) {
            if (
              this.editData.employeeType1.num === "" ||
              this.editData.employeeType1.preWorkHour === ""
            ) {
              this.$message.error("请完善机械工程师数据");
              return false;
            }
          } else if (
            this.editData.employeeType2.num ||
            this.editData.employeeType2.preWorkHour ||
            this.editData.employeeType2.remark
          ) {
            if (
              this.editData.employeeType2.num === "" ||
              this.editData.employeeType2.preWorkHour === ""
            ) {
              this.$message.error("请完善电气工程师数据");
              return false;
            }
          } else if (
            this.editData.employeeType3.num ||
            this.editData.employeeType3.preWorkHour ||
            this.editData.employeeType3.remark
          ) {
            if (
              this.editData.employeeType3.num === "" ||
              this.editData.employeeType3.preWorkHour === ""
            ) {
              this.$message.error("请完善软件工程师数据");
              return false;
            }
          } else if (
            this.editData.employeeType4.num ||
            this.editData.employeeType4.preWorkHour ||
            this.editData.employeeType4.remark
          ) {
            if (
              this.editData.employeeType4.num === "" ||
              this.editData.employeeType4.preWorkHour === ""
            ) {
              this.$message.error("请完善质量工程师数据");
              return false;
            }
          }

          if (
            this.editData.employeeType4.num === "" &&
            this.editData.employeeType4.preWorkHour === "" &&
            this.editData.employeeType3.num === "" &&
            this.editData.employeeType3.preWorkHour === "" &&
            this.editData.employeeType2.num === "" &&
            this.editData.employeeType2.preWorkHour === "" &&
            this.editData.employeeType1.num === "" &&
            this.editData.employeeType1.preWorkHour === ""
          ) {
            this.$message.error("最少输入一种工程数据");
            return false;
          }

          let expartiateList = [];
          if (
            this.editData.employeeType1 &&
            this.editData.employeeType1.num &&
            this.editData.employeeType1.preWorkHour
          ) {
            expartiateList.push({
              ...this.editData.employeeType1,
              startTime: this.editData.startTime,
              employeeType: 0,
              feeType: this.editData.feeType,
            });
          }

          if (
            this.editData.employeeType2 &&
            this.editData.employeeType2.num &&
            this.editData.employeeType2.preWorkHour
          ) {
            expartiateList.push({
              ...this.editData.employeeType2,
              startTime: this.editData.startTime,
              employeeType: 1,
              feeType: this.editData.feeType,
            });
          }

          if (
            this.editData.employeeType3 &&
            this.editData.employeeType3.num &&
            this.editData.employeeType3.preWorkHour
          ) {
            expartiateList.push({
              ...this.editData.employeeType3,
              startTime: this.editData.startTime,
              employeeType: 2,
              feeType: this.editData.feeType,
            });
          }

          if (
            this.editData.employeeType4 &&
            this.editData.employeeType4.num &&
            this.editData.employeeType4.preWorkHour
          ) {
            expartiateList.push({
              ...this.editData.employeeType4,
              startTime: this.editData.startTime,
              employeeType: 3,
              feeType: this.editData.feeType,
            });
          }
          console.log(this.editData);
          let employeeType1Num = this.editData.employeeType1.num + "";
          let employeeType2Num = this.editData.employeeType2.num + "";
          let employeeType3Num = this.editData.employeeType3.num + "";
          let employeeType4Num = this.editData.employeeType4.num + "";
          if (
            this.editData.employeeType1.num &&
            (employeeType1Num.indexOf(".") > -1 || employeeType1Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType2.num &&
            (employeeType2Num.indexOf(".") > -1 || employeeType2Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType3.num &&
            (employeeType3Num.indexOf(".") > -1 || employeeType3Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType4.num &&
            (employeeType4Num.indexOf(".") > -1 || employeeType4Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }

          let employeeType1PreWorkHour =
            this.editData.employeeType1.preWorkHour + "";
          let employeeType2PreWorkHour =
            this.editData.employeeType2.preWorkHour + "";
          let employeeType3PreWorkHour =
            this.editData.employeeType3.preWorkHour + "";
          let employeeType4PreWorkHour =
            this.editData.employeeType4.preWorkHour + "";
          if (
            this.editData.employeeType1.preWorkHour &&
            employeeType1PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType2.preWorkHour &&
            employeeType2PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType3.preWorkHour &&
            employeeType3PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType4.preWorkHour &&
            employeeType4PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }

          this.expartiateList = [...expartiateList];
          this.addPartsFlag = false;
          console.log(expartiateList);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    orderSave() {
      console.log(this.expartiateList, this.from.status);
      if (this.from.handlerId === "") {
        this.$message({
          type: "error",
          message: "处理人不能为空",
        });
        return false;
      } else if (this.expartiateList.length == 0) {
        this.$message({
          type: "error",
          message: "工程师不能为空",
        });
        return false;
      }
      // let expatriatePlanList = [];
      // let feeType = "";
      // for (let index = 0; index < this.expartiateList.length; index++) {
      //   feeType = this.expartiateList[index].feeType;
      //   expatriatePlanList.push({
      //     ...this.expartiateList[index],
      //   });
      // }
      // let from = {
      //   id: this.from.id,
      //   status: this.from.status,
      //   workOrderId: this.from.workOrderId,
      //   feeType: feeType,
      //   handlerId: this.from.handlerId,
      //   expatriatePlanList: [...expatriatePlanList],
      //   serviceInvitation: this.serviceInvitation,
      // };
      // console.log(from);

      if (this.from.status == 8) {
        this.cancelRemarkFlag = true;
        this.cancelRemarkText = "";

        return false;
      }
      this.orderSaveV2();

      // this.ccRequest
      //   .do("admin/fsb/expatriate/save", from, "POSTJSON")
      //   .then((res) => {
      //     this.$message({
      //       type: "success",
      //       message: "操作成功",
      //     });
      //     this.showEdit = false;
      //     this.$emit("updateOrder", true);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     this.$message.error(err.response.data.message);
      //   });
    },
    cancelRemark() {
      this.from.cancelRemark = this.cancelRemarkText;
      this.orderSaveV2();
    },
    orderSaveV2() {
      let expatriatePlanList = [];
      let feeType = "";
      for (let index = 0; index < this.expartiateList.length; index++) {
        feeType = this.expartiateList[index].feeType;
        expatriatePlanList.push({
          ...this.expartiateList[index],
        });
      }
      let from = {
        ...this.from,
        // id: this.from.id,
        // status: this.from.status,
        workOrderId: this.from.workOrderId,
        feeType: feeType,
        // handlerId: this.from.handlerId,
        expatriatePlanList: [...expatriatePlanList],
        serviceInvitation: this.serviceInvitation,
        // cancelRemark: this.from.cancelRemark,
      };
      //處理人操作時
      if (this.isHandleV2) {
        from.operationType = 1;
      }
      console.log(from);
      this.ccRequest
        .do("admin/fsb/expatriate/save", from, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.showEdit = false;
          this.cancelRemarkFlag = false;
          this.$emit("updateOrder", true);
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },

    audit(e, auditResult) {
      if (auditResult == 1) {
        let pData = [{ objId: e.id, auditResult: 1 }];
        this.saveAudit(pData, "本外派工单通过审核？");
      } else {
        let pData = [{ objId: e.id, auditResult: 2 }];
        this.saveAudit(pData, "本外派工单不通过审核？");
      }
    },
    saveAudit(pData, text) {
      if (this.roleTips != "afterSalesManager") {
        this.$message.error("仅售后经理可审批");
        return false;
      }
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/expatriate/audit", pData, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    allAudit() {
      let pData = [];
      for (let index = 0; index < this.expartiateList.length; index++) {
        pData.push({
          objId: this.expartiateList[index].id,
          auditResult: 1,
        });
      }
      this.saveAudit(pData, "所有外派工单通过审核？");
    },
    sendMes() {
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = this.expatriateData;
          let pData = {
            expatriateOrderId: data.id,
          };
          this.ccRequest
            .do("admin/fsb/expatriate/pushCustomer", pData, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    confirmUserOrder() {
      let data = {
        expatriateOrderId: this.expatriateDataV2.id,
      };
      this.$confirm("该操作将帮助客户确认外派订单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/expatriate/expatriateOrderConfirm", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.$emit("updateOrder", true);
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getUserList();

    this.ccRequest
      .do(`validate`, {}, "GET")
      .then((res) => {
        this.roleTips = res.roleTips;
      })
      .catch((err) => {});
  },
};
</script>
<style scoped lang="scss">
.left {
  display: flex;
  align-items: center;
  width: 70%;
  // justify-content: space-between;
  span {
    margin-right: 10px;
    font-weight: bold;
  }
}
.right {
  width: 30%;
  display: flex;
  justify-content: flex-end;
  .btn-group {
    margin-left: 10px;
  }
}
.card {
  padding: 20px;
  background: #f5f7fa;
}
.title_button {
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    // width: 100%;
    // justify-content: space-between;
    div {
      // margin-right: 55px;
    }
    span {
      margin-right: 10px;
      font-weight: bold;
    }
  }
}
.add_title {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-right: 100px;
  }
  span {
    margin-right: 20px;
  }
}
.count_wrap {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .left {
    width: 50%;
    display: flex;
    justify-content: space-between;
  }
}
.cancelRemark_title {
  text-align: center;
  padding-bottom: 20px;
}
.cancelRemark_btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.uploader {
  position: relative;
  height: 200px;
}
.file {
  display: flex;
  align-items: center;
  span {
    min-width: 45px;
    margin-right: 0px;
  }
}
.file2 {
  // margin-top: 10px;
  display: flex;
  margin-right: 143px;
  // width: 100%;
  .file2_title {
    min-width: 45px;
    font-weight: bold;
  }
  .file2_list {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
}
.backAudit_card {
  background: #f5f7fa;
  padding: 20px 20px 20px 20px;
  margin-bottom: 20px;
  span {
    color: red;
    margin-left: 10px;
  }
  > div {
    display: flex;
    align-items: center;
  }
  .name {
    margin-bottom: 20px;
  }
}

.button_wrap {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    margin: 0 10px;
  }
  input {
    margin-right: 20px;
  }
}
</style>

<style >
.ExpartiateList .el-link--inner {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>